import { gql } from 'graphql-request';
import { fragmentCoding } from '../fragments';

// gql-tagged (not a plain string) so graphql-codegen plucks `fragment Claim` and can resolve
// `...Claim` in the query. The `...Coding` reference resolves against the separately-plucked
// `fragmentCoding`. At runtime `gql` is an identity tag, so interpolation is unchanged.
export const fragmentClaim = gql`
  ${fragmentCoding}
  fragment Claim on Claim {
    id
    resourceType
    meta {
      tag {
        system
        code
      }
      versionId
    }
    billablePeriod {
      start
      end
    }
    type {
      coding {
        ...Coding
      }
    }
    diagnosis {
      sequence
      diagnosisCodeableConcept {
        coding {
          ...Coding
        }
      }
    }
    item {
      sequence
      productOrService {
        coding {
          ...Coding
        }
      }
    }
  }
`;
